module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-101.fea82f5d.svg";